module.exports = __webpack_public_path__ + "static/prescription-preview-image-7e41d9f4ed251925992489b9eb3d1d7c.png";